import api from './api';

export default {
  getProductTypes() {
    return new Promise((resolve, reject) => {
      api
        .get(`product-type`)
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  updateProductType(id, updates) {
    return new Promise((resolve, reject) => {
      api
        .put(`product-type/${id}`, { updates })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  addProductType(productType) {
    return new Promise((resolve, reject) => {
      api
        .post(`product-type`, productType)
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  deleteProductType(id) {
    return new Promise((resolve, reject) => {
      api
        .delete(`product-type/${id}`)
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  }
};
